import PropTypes from "prop-types";
import EmailBody from "../../../../../components/emailer/email-body";

const EmailTemplateForm = ({
  templateName,
  setTemplateName,
  templateSubject,
  setTemplateSubject,
  templateBody,
  setTemplateBody,
  quillRef,
}) => {
  return (
    <div className="templates-library--container" style={{ width: "70%" }}>
      <div className="email-form">
        <div style={{ maxHeight: "550px" }}>
          <div className="email-form-header">
            <div className="email-form-header-field">
              <label className="email-form--label">
                <strong className="email-form-header-label">Name:</strong>
                <input
                  className="email-form--input-field"
                  style={{ marginLeft: "5px", padding: "10px 0px 10px 10px" }}
                  value={templateName}
                  placeholder={"Write template name here..."}
                  onChange={({ target: { value } }) => setTemplateName(value)}
                  data-testid="subject-field"
                />
              </label>
              <hr className="email-form-header-hr" />
            </div>
            <div className="email-form-header-field email-subject">
              <label className="space-between email-form--label">
                <strong>Subject:</strong>
                <input
                  className="email-form--input-field"
                  style={{ marginLeft: "5px" }}
                  value={templateSubject}
                  placeholder={"Write subject..."}
                  onChange={({ target: { value } }) => setTemplateSubject(value)}
                  data-testid="subject-field"
                />
              </label>
              <hr className="email-form-header-hr" />
            </div>
          </div>
          <div className="email-form--body" data-testid="body-field">
            <EmailBody
              showLinkAndImageOptions={false}
              emailBody={templateBody}
              setEmailBody={setTemplateBody}
              className={"edit-email--body-inner"}
              quillRef={quillRef}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

EmailTemplateForm.propTypes = {
  templateName: PropTypes.string,
  setTemplateName: PropTypes.func,
  templateSubject: PropTypes.string,
  setTemplateSubject: PropTypes.func,
  templateBody: PropTypes.string,
  setTemplateBody: PropTypes.func,
  quillRef: PropTypes.object,
};

export default EmailTemplateForm;
